import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "offer-details-catalogue-modal" }

import type { ClientType } from '@/interfaces/common';
import type { HotelCatalogueType } from '@/interfaces/hotel-catalogue-types';
import { determineClient } from '@/js/utils/environmentUtils';
import BaseModal from '@lmt-rpb/BaseModal/BaseModal.vue';
import CatalogueInfo from '@lmt-rpb/CatalogueInfo/CatalogueInfo.vue';
import Loading from '@lmt-rpb/Loading/Loading.vue';
import { useTranslations } from 'src/storybook/src/composables/translations';
interface Props {
	catalogueInfoData: HotelCatalogueType | null;
	client: ClientType;
	isLoading?: boolean;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'OfferDetailsCatalogueModal',
  props: {
    catalogueInfoData: {},
    client: { default: () => (determineClient()) },
    isLoading: { type: Boolean }
  },
  emits: ["operatorChange", "catalogueModalOpen"],
  setup(__props: any) {




const { translate } = useTranslations();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(BaseModal, {
      label: _unref(translate)('offer.details'),
      "with-open-button": "",
      "header-title": _unref(translate)('offer.details'),
      "open-button-props": {
				label: _unref(translate)('offer.details'),
				bold: true,
			},
      "full-height": "",
      onOpen: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('catalogueModalOpen')))
    }, {
      default: _withCtx(() => [
        (_ctx.isLoading)
          ? (_openBlock(), _createBlock(Loading, {
              key: 0,
              "unique-key": "catalogue",
              class: "offer-details-catalogue-modal__catalogue-loading"
            }))
          : (_ctx.catalogueInfoData && !_ctx.isLoading)
            ? (_openBlock(), _createBlock(CatalogueInfo, {
                key: 1,
                "catalogue-info": _ctx.catalogueInfoData,
                client: _ctx.client,
                class: "offer-details-catalogue-modal__catalogue-info",
                onOperatorChanged: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('operatorChange', $event)))
              }, null, 8 /* PROPS */, ["catalogue-info", "client"]))
            : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["label", "header-title", "open-button-props"])
  ]))
}
}

})